import { Navigate, useParams } from "react-router-dom";

export default function ServicePage() {
  const { slug } = useParams();
  return <Navigate to={`/?servico=${encodeURIComponent(slug)}`} replace />;
}
